import React, {useState, useEffect} from "react";

import "./index.css";
import Button2 from "../../common/Button2";
import Container from "../../common/Container";
import axios from "axios";
import { Link } from "react-router-dom";

const Newsletter = () => {
    const [mail, setMail] = useState<string>("");
    const [color, setColor] = useState<string>("gray");

    const [state, setState] = useState<string>("eingabe");
    const [response, setResponse] = useState<string>("nothing");

    const checkState = (s:string) => {
        if (s === ""){
            setColor('gray')
        } else if (!s.includes("@")) {
            setColor('red');
        }
        else {
            setColor('green');
        }
    }

    const handleSubmit = () => {
        if (!mail.includes("@")) {
            setColor('red');
        } else {
            setColor('green');
            const url = "https://radentscheid-goe.de/api/server.php";

            let fData = new FormData();
            fData.append('mail', mail);

            axios.post(url, fData)
            .then(
                response => setResponse(response.data)
            )
            .catch(
                error => {console.log(error); setState("fehler");}
            )
        }
    };

    // triggered on change of response
    useEffect(
        () => {
            if (response === "nothing"){
                setState("eingabe");
            } else if (response === "SUCCESS") {
                setState("abgeschlossen");
            } else if (response === "ERROR"){
                setState("fehler");
            } else {
                setState("eingabe");
            }
        }, [response]
    )

    interface NewsletterKachelProps {
        title: string;
        content:string;
        date: string;
        url: string;

    }
    const NewsletterKachel = ({title, date, content, url}:NewsletterKachelProps) => {
        return (
            <a href={url}
               target="_blank"
               rel="noopener noreferrer"
               className="kachel"
               style={{ textDecoration: 'none', color: 'black', display: 'block' }} // Verhindert typisches Link-Styling
            >
                <h3 style={{ color: 'inherit' }}>Veröffentlicht am {date}</h3>
                <h2 style={{ color: 'inherit' }}>{title}</h2>
                <p style={{ color: 'inherit' }}>{content}<br/><i>Weiterlesen...</i></p>
            </a>
        );
    }
    const NewsletterKachel_open_in_same_tab = ({title, date, content, url}:NewsletterKachelProps) => {
        return (
            <div className="kachel" onClick={() => {
                setTimeout(() => {
                    document.body.style.cursor = 'default';
                }, 1);
                window.location.href = url;
                window.scrollTo(0, 0);
            }}
                 onMouseEnter={() => {
                     document.body.style.cursor = 'pointer';
                 }}
                 onMouseLeave={() => {
                     document.body.style.cursor = 'default';
                 }}>
                <h3>Veröffentlicht am {date}</h3>
                <h2>{title}</h2>
                <p>{content}<br/><i>Weiterlesen...</i></p>
            </div>
        );
    }
    const Anmeldung = <>
        <div>
            <p>
                Trage einfach deine E-Mail-Adresse ein und verpasse
                nichts mehr von GöttingenZero und
                davon wie's mit dem Radentscheid weitergeht.</p>
            <input
                about="text"
                value = {mail}
                onChange = {(e) => {
                    checkState(`${e.target.value}`);
                    setMail(`${e.target.value}`);
                }}
                style = {{border: `solid thick ${color}`}}
            />
        </div>
        <Button2
            content="anmelden"
            onClick={handleSubmit}
        />
        <div>
                <Link to = "./abmeldung-newsletter">Hier kannst du dich wieder vom Newsletter abmelden.</Link>
        </div>
        </>

    const Erfolg = <>
        <div className="erfolg">
                <p>Du wurdest dem Verteiler des Newsletters erfolgreich hinzugefügt! :-)</p>
        </div>
    </>

    const Fehler = <>
        <div className="fehler">
                <p>Das hat leider nicht geklappt! Probiere es gleich noch einmal oder schreibe uns eine E-Mail und wir fügen dich manuell hinzu. :-)</p>
        </div>
        <Button2
            content = "Neu eingeben"
            onClick={() => {
                setState("eingabe");
            }}
        />
    </>


    return (
        <Container>
            <div className="newsletter-wrapper">
                <div>
                    <h1>Unser Newsletter</h1>
                    <div className="letters">
                        <NewsletterKachel
                            date={"9. April 2026"}
                            title={"4. Newsletter"}
                            content={"Unsere nächste Kampagne: Die Wahl des*der Oberbürgermeister*in! Und natürlich gibt es auch Aktuelles zum Radentscheid, dem Klimabericht 2024 und zur Wärmewende"}
                            url={"https://epgdc.r.a.d.sendibm1.com/mk/mr/sh/6rqJ8GoudeITPxTHObA4IiCWNL6/SNdNtePdqoPn"}
                        />
                        <NewsletterKachel_open_in_same_tab
                            date={"27. Oktober 2025"}
                            title={"3. Newsletter"}
                            content={"Unter anderem mit Update zum Radentscheid, zur Göttinger Wärmewende und anstehenden Veranstaltungen"}
                            url={"/#/newsletter/3"}
                        />
                        <NewsletterKachel_open_in_same_tab
                            date={"13. Februar 2025"}
                            title={"2. Newsletter"}
                            content={"Unter anderem mit Update zum Radentscheid, den Klimabericht 2023 und der Göttinger Wärmewende"}
                            url={"/#/newsletter/2"}
                        />
                        <NewsletterKachel_open_in_same_tab
                            date={"19. November 2024"}
                            title={"1. Newsletter"}
                            content={"Unter anderem mit Update zum Radentscheid und Klimaplan 2030"}
                            url={"/#/newsletter/1"}
                        />
                    </div>
                </div>
                <div>
                    <h2>Melde dich an</h2>
                    {
                        state === 'eingabe' ? Anmeldung : (state === 'abgeschlossen' ? Erfolg : Fehler)
                    }
                </div>
            </div>
        </Container>
    )
}

export default Newsletter;